import React from "react"
import { graphql } from "gatsby"
import Layout from "../../components/Layout/layout"
import SEO from "../../components/seo"
import FormulairePaiement from "../../components/FormulairePaiement/formulaire-paiement"
import PropTypes from "prop-types"
import Ariane from "../../components/Ariane/ariane"

//-----------------------QueryGraphql---------------------------//

export const query = graphql`
  query ($slug: String!) {
    nodeFormulairePaiement(path: { alias: { eq: $slug } }) {
      title
      created(formatString: "DD/MM/YYYY", locale: "fr")
      body {
        summary
        processed
      }
      path {
        alias
      }
      field_code_exercice
      field_description_de_la_referenc {
        processed
      }
      field_mode_de_saisie
      field_roldeb
      field_rolrec
      field_type_de_formulaire
      field_id_ligne
      field_num_ordre
    }
  }
`
//-----------------------QueryGraphql---------------------------//

//-----------------------Component---------------------------//

const FormulairePaiementTemplate = ({ data, location }) => {
  const formulairepaiement = data.nodeFormulairePaiement
  return (
    <Layout isDetail={true}>
      <SEO title={formulairepaiement.title} />
      <Ariane isListing={true} pageName={formulairepaiement.title} />
      <FormulairePaiement
        location={location}
        formulairePaiement={formulairepaiement}
      />
    </Layout>
  )
}

//-----------------------Component---------------------------//

//-----------------------Prop-Types---------------------------//

FormulairePaiementTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  location: PropTypes.object,
}

//-----------------------Prop-Types---------------------------//

export default FormulairePaiementTemplate
